/*---------------------------------------*\
   Import classes
\*---------------------------------------*/

//Components
import {Header} from "./Components/Header";
import {Micromodal} from "./Components/Micromodal";
import {Ajax} from "./Components/Ajax";
import {Kariera} from "./Components/Kariera";
import {PostSlider} from "./Components/PostSlider";
import {SubscriptionNotification} from "./Components/SubscriptionNotification";
import {ThemePopup} from "./Components/ThemePopup";
import {FooterStickyAd} from "./Components/FooterStickyAd";
import {ShareArticle} from "./Components/ShareArticle";

var $ = jQuery;

/*---------------------------------------*\
   Init Functions
\*---------------------------------------*/
$(document).ready(function () {
    // Float label for smartEmailing form
    Header.init();
    Micromodal.init();
    Ajax.init();
    Kariera.init();
    PostSlider.init();
    SubscriptionNotification.init();
    ThemePopup.init();
    FooterStickyAd.init();
    ShareArticle.init();
});
